module.exports = __webpack_public_path__ + "img/1L1.b0cc39bb.png";